require("./..\\..\\bower_components\\bootstrap\\dist\\js\\bootstrap.js");

$('[data-toggle="tooltip"]').tooltip();

$('.j_searchToggle').on('click', function(){
    $('.j_searchContainer').toggleClass('active');
});